<template>
  <el-form-item :label="isUpdate ? '' : label" :label-width="isUpdate ? '0px' : '120px'" :prop="field" ref="fileInfos"
    :style="{ marginBottom: isUpdate ? '0px' : '18px' }" class="cf">
    <el-upload list-type="picture-card" action :file-list="data[field]" :limit="limit" :http-request="upLoad"
      :on-preview="handlePictureCardPreview" :before-upload="beforeUp" :on-remove="handleRemove" class="fl"
      :class="hideUpload ? 'hide img-upload' : 'img-upload'" multiple :on-change="handlechange" :auto-upload="true"
      accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP,">
      <i class="el-icon-plus"></i>
    </el-upload>
    <div style="margin-left: 5px; font-size: 10px; width: 100px; height: 80px; line-height: 80px;" class="fl">
      最多上传{{ limit }}张图片
    </div>
    <el-image ref="previewRef" class="hideImgDiv" :src="dialogImageUrl" :preview-src-list="[dialogImageUrl]"></el-image>
  </el-form-item>
</template>
<script>
import XEUtils from "xe-utils";

export default {
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      hideUpload: false,
      formData: null,
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: '上传图片'
    },
    rules: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 10
    },
    isUpdate: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    model: {
      type: String,
      default: 'coal_laboratory'
    },
  },
  computed: {
    fieldValue() {
      return this.data[this.field];
    }
  },
  watch: {
    fieldValue() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    marginBottom() {
      return marginBottom
    },
    init() {
      this.$nextTick(() => {
        if (!XEUtils.isArray(this.data[this.field])) {
          this.$set(this.data, this.field, [])
        }
        this.hideUpload = this.data[this.field].length >= this.limit
      })
      this.getRules()
    },
    getRules() {
      if (this.required) {
        this.$set(this.rules, this.field, [{
          required: this.required,
          message: '上传失败',
          trigger: 'blur'
        }])
      }
    },
    beforeUp(file) {
      let suffix = this.getFileType(file.name)
      const suffixArray = ["jpg", "jpeg", "png", "gif", "bmp", "JPG", "JPEG", "PBG", "GIF", "BMP"]
      if (suffixArray.indexOf(suffix) === -1 && suffixArray.length !== 0) {
        this.$message({
          message: '请上传图片',
          type: 'error',
          duration: 2000
        })
        return false
      } else {
        this.formData = new FormData()
        this.formData.append('contractFile', file)
        this.formData.append('modelCode', this.model)
        this.formData.append('fieldCode', this.field)
      }
    },
    getFileType(name) {
      let startIndex = name.lastIndexOf('.')
      if (startIndex !== -1) {
        return name.slice(startIndex + 1).toLowerCase()
      } else {
        return ''
      }
    },
    upLoad(file) {
      if (this.limit === 1) {
        this.hideUpload = true
      }
      const type = this.getFileType(file.file.name)
      this.$axios.post('/account/oss/ossFile', this.formData).then((res) => {
        if (res) {
          this.data[this.field].push({
            name: file.file.name,
            url: res.data.data.url,
            type: type,
          })
          this.$set(this, 'hideUpload', this.data[this.field].length >= this.limit)
          setTimeout(() => {
            if (this.isUpdate) {
              this.$emit('init')
            }
          }, 1500)
        } else {
          this.$set(this, 'hideUpload', fileList.length >= this.limit)
          this.$message.warning('上传失败')
        }
      })
    },
    handleRemove(file) {
      try {
        this.data[this.field].forEach((item, index) => {
          if (file.url === item.url) {
            this.data[this.field].splice(index, 1)
            this.$set(this, 'hideUpload', this.data[this.field].length >= this.limit)
          }
        })
        if (this.isUpdate) {
          this.$emit('init')
        }
      } catch (e) {
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.$refs.previewRef.clickHandler()
    },
    handlechange(file, fileList) {
      this.$set(this, 'hideUpload', fileList.length >= this.limit)
    },
  }
}
</script>
<style>
.hide .el-upload--picture-card {
  display: none !important;
}

.img-upload .el-upload--picture-card {
  height: 80px !important;
  line-height: 80px !important;
  width: 80px !important;
}

.img-upload .el-upload-list__item {
  height: 80px !important;
  transition: none !important;
  width: 80px !important;
}

.hideImgDiv {
  display: block !important;
}

.hideImgDiv .el-image__inner {
  display: none !important;
}

.hideImgDiv .el-image__error {
  display: none !important;
}
</style>
